export const PLAYBACK_DEVICE_NOT_FOUND = 'PLAYBACK_DEVICE_NOT_FOUND';
export const PLAYBACK_NOT_ENOUGH_SONGS = 'NOT_ENOUGH_SONGS';
